import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 76 58" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.936523 17.8576V57.4801H75.1941V17.5806" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.1885 0.817139H64.9421" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6952 36.1449C16.6952 36.1449 19.5006 36.9761 18.3577 34.4824C17.2148 31.9886 15.864 29.4949 15.3445 28.6637C14.825 27.8324 14.6171 27.3129 13.2664 27.1051C11.9156 26.8973 9.31797 26.3778 6.82431 25.8583C5.76231 25.637 4.12281 24.0919 3.60322 25.5465C3.08372 27.0012 2.77197 30.3262 2.77197 30.8457C2.77197 31.3652 2.77197 32.4043 5.05789 33.1316C7.34381 33.8589 15.3445 35.8331 16.6952 36.1449Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8.07129 25.7545C8.07129 25.7545 6.09712 22.2217 7.86346 19.9358" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.6622 15.6653C23.9183 15.6653 22.5659 15.1665 22.5659 13.982C22.5659 12.7975 22.6335 12.0494 22.7012 11.5506C22.7688 11.0519 23.2422 10.4285 24.2564 10.4285C25.2708 10.4285 26.8936 10.4285 27.6374 10.4285C28.4488 10.4285 28.9222 10.8649 28.9898 11.426C29.1348 12.6291 29.2603 13.3586 29.2603 14.1067C29.2603 14.8548 28.6518 15.7276 27.5023 15.7276C26.4879 15.7276 24.6622 15.6653 24.6622 15.6653Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.2905 10.3267C26.3164 9.87933 26.3531 9.53533 26.3898 9.26474C26.4574 8.76599 26.9308 8.14258 27.945 8.14258C28.9594 8.14258 30.5822 8.14258 31.326 8.14258C32.1374 8.14258 32.6108 8.57899 32.6784 9.14008C32.8234 10.3432 32.9489 11.0727 32.9489 11.8208C32.9489 12.5689 32.3404 13.4417 31.1909 13.4417C30.6474 13.4417 29.8711 13.4238 29.2674 13.4072"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M31.1909 13.4416C31.1909 13.4416 34.4113 13.078 34.671 14.7405C34.7756 15.4097 34.8788 15.8315 34.8788 15.8315" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M73.0926 32.7161C73.0926 32.7161 75.7941 47.9901 69.1442 52.1463C62.4943 56.3026 42.4405 55.6791 38.4922 55.6791H37.6843C33.7359 55.6791 13.6822 56.3025 7.0323 52.1463C0.38238 47.9901 3.08388 32.7161 3.08388 32.7161"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.4807 36.1449C59.4807 36.1449 56.6753 36.9761 57.8182 34.4824C58.9611 31.9886 60.3119 29.4949 60.8314 28.6637C61.3509 27.8324 61.5588 27.3129 62.9095 27.1051C64.2603 26.8973 66.8579 26.3778 69.3516 25.8583C70.4136 25.637 72.0531 24.0919 72.5727 25.5465C73.0922 27.0012 73.4039 30.3262 73.4039 30.8457C73.4039 31.3652 73.4039 32.4043 71.118 33.1316C68.8321 33.8589 60.8314 35.8331 59.4807 36.1449Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M68.105 25.7545C68.105 25.7545 70.0791 22.2217 68.3128 19.9358" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M64.4685 35.2097C64.4685 35.2097 63.3255 39.366 58.2342 40.0933C53.1428 40.8206 40.9227 40.9246 38.1173 40.9246H38.0307C35.2253 40.9246 23.0337 40.8206 17.9423 40.0933C12.851 39.366 11.708 35.2097 11.708 35.2097"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.2213 39.6777C62.494 40.8207 61.2472 41.7558 59.5847 41.8597C57.9222 41.9637 39.7264 42.6585 38.1451 42.6585C38.0324 42.6585 38.0303 42.665 37.8745 42.665C26.8433 42.665 18.2538 41.9637 16.5913 41.8597C14.9288 41.7558 13.6819 40.8207 12.9546 39.6777"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.7407 15.7795C63.7407 15.7795 64.2603 17.546 61.4548 17.9615C58.6494 18.3771 48.7784 19.0006 38.1801 19.0006H37.9956C27.3972 19.0006 17.5263 18.3772 14.7208 17.9615C11.9154 17.546 12.4349 15.7795 12.4349 15.7795"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M57.4029 6.53192C57.4029 6.53192 54.0681 4.97217 51.3764 4.66159C48.6749 4.34984 44.8304 4.14209 38.1804 4.14209H37.9959C31.346 4.14209 27.5015 4.34992 24.7999 4.66159C22.1083 4.97217 18.7734 6.53192 18.7734 6.53192"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.5142 15.6653C52.258 15.6653 53.6104 15.1665 53.6104 13.982C53.6104 12.7975 53.5428 12.0494 53.4752 11.5506C53.4076 11.0519 52.9342 10.4285 51.9199 10.4285C50.9056 10.4285 49.2828 10.4285 48.5389 10.4285C47.7275 10.4285 47.2542 10.8649 47.1865 11.426C47.0415 12.6291 46.916 13.3586 46.916 14.1067C46.916 14.8548 47.5246 15.7276 48.6741 15.7276C49.6884 15.7276 51.5142 15.6653 51.5142 15.6653Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M49.8855 10.3267C49.8596 9.87933 49.8229 9.53533 49.7862 9.26474C49.7186 8.76599 49.2452 8.14258 48.231 8.14258C47.2166 8.14258 45.5938 8.14258 44.85 8.14258C44.0386 8.14258 43.5652 8.57899 43.4976 9.14008C43.3526 10.3432 43.2271 11.0727 43.2271 11.8208C43.2271 12.5689 43.8356 13.4417 44.9851 13.4417C45.5286 13.4417 46.305 13.4238 46.9086 13.4072"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M44.9853 13.4416C44.9853 13.4416 41.7649 13.078 41.5052 14.7405C41.4006 15.4097 41.2974 15.8315 41.2974 15.8315" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M60.4161 15.8834L38.0998 16.0912H38.0479L15.7603 15.8834" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M71.5338 24.7153C71.5338 24.7153 70.8064 21.806 69.8713 20.9747C68.9361 20.1435 65.1922 18.1202 63.533 14.7404C60.7276 9.02566 55.5323 4.76549 55.5323 4.76549C52.5191 2.27174 38.1802 2.51424 38.1802 2.51424H37.9957C37.9957 2.51424 23.6568 2.27182 20.6435 4.76549C20.6435 4.76549 15.4483 9.02557 12.6428 14.7404C10.9837 18.1202 7.23976 20.1435 6.30459 20.9747C5.36942 21.806 4.64209 24.7153 4.64209 24.7153"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.1801 38.7426C39.1153 38.7426 45.5574 38.7426 47.4277 38.4309C49.298 38.1191 50.9605 37.4957 51.8956 35.4176C52.8308 33.3395 53.2464 31.0536 53.3503 30.2224C53.4542 29.3911 53.2464 29.0795 52.1035 29.2872C50.9605 29.495 45.1418 30.1185 38.1801 30.1185H37.892C30.9304 30.1185 25.1117 29.495 23.9687 29.2872C22.8258 29.0794 22.618 29.3911 22.7219 30.2224C22.8258 31.0536 23.2414 33.3395 24.1765 35.4176C25.1117 37.4957 26.7742 38.1191 28.6445 38.4309C30.5148 38.7426 36.9569 38.7426 37.892 38.7426H38.1801Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Icon;
